import './style.sass';
import { CampaignStatus } from 'common/types/models/campaign';
import React from 'react';
import checkmark from 'assets/img/icons/transperencyCheckmark.svg';
import { ReactSVG } from 'react-svg';
import { CampaignStatusTitle } from 'app/utils/campaignStatusHelpers';

type Props = {
    activeStep: CampaignStatus,
};

const steps = [CampaignStatus.Pending, CampaignStatus.Active, CampaignStatus.Approved, CampaignStatus.Completed];
const errorSteps = [CampaignStatus.Canceled, CampaignStatus.Refunded, CampaignStatus.Disputed, CampaignStatus.Hold];

export const CampaignSteps = ({ activeStep }: Props) => {
    const isErrorStep = errorSteps.includes(activeStep);

    const activeIndex = steps.indexOf(activeStep);

    return (
        <div className="campaign-steps">
            {isErrorStep
                ? (
                    <div className="step error">
                        <div className="step__icon"></div>

                        <h3 className="step__subtitle title-h3 dark-violet">{CampaignStatusTitle[activeStep]}</h3>
                        <p className="step__title p2-medium grey-1">Check your email for further clarification</p>
                    </div>
                )
                : steps.map((step, i) => {
                    const isActive = i === activeIndex;
                    const isCompleted = activeIndex >= i;

                    return (
                        <div className={`step ${isActive ? 'active' : ''} ${isCompleted ? 'completed' : ''}`}>
                            <div className="step__icon">
                                <ReactSVG src={checkmark} className="checkmark"/>
                            </div>

                            <span className="step__subtitle p2-medium grey-2">{`Step ${i + 1}`}</span>
                            <h3 className="step__title title-h3 grey-1">{CampaignStatusTitle[step]}</h3>
                        </div>
                    );
                })
            }
        </div>
    );
};
